/** @module Enums */ /** typedoc */

export enum ApplicationEnum {
    Artist = 'Artist', // Promolinks
    Auth0 = 'Auth0',
    DesktopV2 = 'DesktopV2',
    GuestSite = 'GuestSite',
    Layout = 'Layout',
    Library = 'Library',
    Projects = 'Projects',
    RootApp = 'RootApp',
    SamplesIngestionWizard = 'SamplesIngestionWizard',
    SamplesMarketplace = 'SamplesMarketplace',
    Services = 'Services',
    Web = 'Web',
}
